import {
  TTranslationEvent,
} from '@/components/item-notification/item-notification.ts';

const event: TTranslationEvent = {
  job_finished: {
    label: '{assetDisplayName}: Charge {displayName} ist fertig',
    description: 'Charge {displayName} mit Rezept: {recipeDisplayName} ist fertig am {finishedAtUtc} auf {assetDisplayName} in {locationDisplayName}.\nChargesbeschreibung: {description}',
  },
  job_started: {
    label: '{assetDisplayName}: Neue Charge {displayName} wurde gestartet',
    description: 'Charge {displayName} mit Rezept: {startedAtUtc} ist fertig am {finishedAtUtc} auf {assetDisplayName} in {locationDisplayName}.\nChargebeschreibung: {description}',
  },
  timeseries_lag_detected: {
    label: '{assetDisplayName}: Timeseries-Verzögerung erkannt',
    description: 'Timeseries-Verzögerung erkannt auf {assetDisplayName} in {locationDisplayName}',
  },
  alarm_occurred: {
    label: '{assetDisplayName}: {severityTranslation} {alarmDisplayName}',
    description: '{severityTranslation} {alarmDisplayName} aufgetreten auf {assetDisplayName} in {locationDisplayName}',
  },
  new_qmulus_release: {
    label: 'Neue Qmulus Version',
    description: 'Qmulus v{version} wurde gerade veröffentlicht. In den Versionshinweisen erfahren Sie mehr',
  },
  control_level_exceeded: {
    label: 'Kontrollniveau überschritten',
    description: 'Das Kontrollniveau der Sensormessungen wurde überschritten',
  },
  drift_detected: {
    label: 'Drift erkannt',
    description: 'Die Sensormessungen weichen von den Referenzwerten ab',
  },
  trend_detected: {
    label: 'Trend erkannt',
    description: 'Qmulus hat einen neuen Trend in den Sensormessungen erkannt',
  },
  maintenance_occurrence_state_changed: {
    label: 'Wartungsstatus geändert',
    description: 'Der Status von \'{seriesDisplayName}\' Wartung an {assetDisplayName} wurde zu {maintenanceStateTranslation} geändert.',
  },
};

export default {
  markAsRead: 'Als gelesen markieren',
  goToEvent: 'Zum Ereignis gehen',
  event,
  timeseriesLagStopped: {
    label: '{assetDisplayName}: Timeseries-Verzögerung beendet',
    description: 'Timeseries-Verzögerung auf {assetDisplayName} in {locationDisplayName} beendet',
  },
};
